module.exports = __webpack_public_path__ + "img/logo_3nweb.fbdc45ac.png";